module.exports = __webpack_public_path__ + "img/Pinners_squarepromo.cb474530.jpg";